const ledgerActionTypes = {
    START_GET_CURRENCIES: 'START_GET_CURRENCIES',
    SUCCESS_GET_CURRENCIES: 'SUCCESS_GET_CURRENCIES',

    START_FETCH_CURRENCIES_ID: 'START_FETCH_CURRENCIES_ID',
    SUCCESS_FETCH_CURRENCIES_ID: 'SUCCESS_FETCH_CURRENCIES_ID',

    START_FETCH_DEPOSIT_METHODS: 'START_FETCH_DEPOSIT_METHODS',
    SUCCESS_FETCH_DEPOSIT_METHODS: 'SUCCESS_FETCH_DEPOSIT_METHODS',

    START_USER_BANK_ACCOUNTS_ID: 'START_USER_BANK_ACCOUNTS_ID',
    SUCCESS_USER_BANK_ACCOUNTS_ID: 'SUCCESS_USER_BANK_ACCOUNTS_ID',

    REFRESH_DATA: 'REFRESH_DATA',
    UPDATE_SECTIONS: 'UPDATE_SECTIONS',

    START_COUNTRIES_LIST: 'START_COUNTRIES_LIST',
    SUCCESS_COUNTRIES_LIST: 'SUCCESS_COUNTRIES_LIST',
    FAILURE_COUNTRIES_LIST: 'FAILURE_COUNTRIES_LIST',

    START_BANK_ACCOUNT_ORDER: 'START_BANK_ACCOUNT_ORDER',
    SUCCESS_BANK_ACCOUNT_ORDER: 'SUCCESS_BANK_ACCOUNT_ORDER',
    FAILURE_BANK_ACCOUNT_ORDER: 'FAILURE_BANK_ACCOUNT_ORDER',
    FINISH_BANK_ACCOUNT_ORDER: 'FINISH_BANK_ACCOUNT_ORDER',

    START_OPEN_BANK_ACCOUNTS_AVAILABLE: 'START_OPEN_BANK_ACCOUNTS_AVAILABLE',
    SUCCESS_OPEN_BANK_ACCOUNTS_AVAILABLE: 'SUCCESS_OPEN_BANK_ACCOUNTS_AVAILABLE',

    START_TOP_UP_WITH_BANK_TRANSFER: 'START_TOP_UP_WITH_BANK_TRANSFER',
    SUCCESS_TOP_UP_WITH_BANK_TRANSFER: 'SUCCESS_TOP_UP_WITH_BANK_TRANSFER',
    FINISH_TOP_UP_WITH_BANK_TRANSFER: 'FINISH_TOP_UP_WITH_BANK_TRANSFER',
    FAILURE_TOP_UP_WITH_BANK_TRANSFER: 'FAILURE_TOP_UP_WITH_BANK_TRANSFER',

    START_LEDGER_TOP_UP_WITH_NO_CARD_DATA: 'START_LEDGER_TOP_UP_WITH_NO_CARD_DATA',
    SUCCESS_LEDGER_TOP_UP_WITH_NO_CARD_DATA: 'SUCCESS_LEDGER_TOP_UP_WITH_NO_CARD_DATA',
    FINISH_LEDGER_TOP_UP_WITH_NO_CARD_DATA: 'FINISH_LEDGER_TOP_UP_WITH_NO_CARD_DATA',
    FAILURE_LEDGER_TOP_UP_WITH_NO_CARD_DATA: 'FAILURE_LEDGER_TOP_UP_WITH_NO_CARD_DATA',

    START_LEDGER_TOP_UP_WITH_ONLINE_BANK: 'START_LEDGER_TOP_UP_WITH_ONLINE_BANK',
    SUCCESS_LEDGER_TOP_UP_WITH_ONLINE_BANK: 'SUCCESS_LEDGER_TOP_UP_WITH_ONLINE_BANK',
    FINISH_LEDGER_TOP_UP_WITH_ONLINE_BANK: 'FINISH_LEDGER_TOP_UP_WITH_ONLINE_BANK',
    FAILURE_LEDGER_TOP_UP_WITH_ONLINE_BANK: 'FAILURE_LEDGER_TOP_UP_WITH_ONLINE_BANK',

    START_SECURE_3D_CARD: 'START_SECURE_3D_CARD',
    SUCCESS_SECURE_3D_CARD: 'SUCCESS_SECURE_3D_CARD',
    FINISH_SECURE_3D_CARD: 'FINISH_SECURE_3D_CARD',
    FAILURE_SECURE_3D_CARD: 'FAILURE_SECURE_3D_CARD',

    START_SECURE_3D_ONLINE_BANK: 'START_SECURE_3D_ONLINE_BANK',
    SUCCESS_SECURE_3D_ONLINE_BANK: 'SUCCESS_SECURE_3D_ONLINE_BANK',
    FINISH_SECURE_3D_ONLINE_BANK: 'FINISH_SECURE_3D_ONLINE_BANK',
    FAILURE_SECURE_3D_ONLINE_BANK: 'FAILURE_SECURE_3D_ONLINE_BANK',

    START_BANK_ACCOUNT_INTERNAL_TRANSFER: 'START_BANK_ACCOUNT_INTERNAL_TRANSFER',
    SUCCESS_BANK_ACCOUNT_INTERNAL_TRANSFER: 'SUCCESS_BANK_ACCOUNT_INTERNAL_TRANSFER',
    FINISH_BANK_ACCOUNT_INTERNAL_TRANSFER: 'FINISH_BANK_ACCOUNT_INTERNAL_TRANSFER',
    FAILURE_BANK_ACCOUNT_INTERNAL_TRANSFER: 'FAILURE_BANK_ACCOUNT_INTERNAL_TRANSFER',

    START_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: 'START_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY',
    SUCCESS_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: 'SUCCESS_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY',
    FINISH_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: 'FINISH_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY',
    FAILURE_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: 'FAILURE_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY',

    START_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: 'START_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY',
    SUCCESS_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: 'SUCCESS_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY',
    FINISH_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: 'FINISH_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY',
    FAILURE_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: 'FAILURE_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY',

    START_FEE_CALCULATOR: 'START_FEE_CALCULATOR',
    SUCCESS_FEE_CALCULATOR: 'SUCCESS_FEE_CALCULATOR',
    FINISH_FEE_CALCULATOR: 'FINISH_FEE_CALCULATOR',
    FAILURE_FEE_CALCULATOR: 'FAILURE_FEE_CALCULATOR',

    START_MERGED_FEE_CALCULATOR: 'START_MERGED_FEE_CALCULATOR',
    SUCCESS_MERGED_FEE_CALCULATOR: 'SUCCESS_MERGED_FEE_CALCULATOR',
    FINISH_MERGED_FEE_CALCULATOR: 'FINISH_MERGED_FEE_CALCULATOR',
    FAILURE_MERGED_FEE_CALCULATOR: 'FAILURE_MERGED_FEE_CALCULATOR',

    START_EXCHANGE_All_ASSETS: 'START_EXCHANGE_All_ASSETS',
    SUCCESS_EXCHANGE_All_ASSETS: 'SUCCESS_EXCHANGE_All_ASSETS',
    FINISH_EXCHANGE_All_ASSETS: 'FINISH_EXCHANGE_All_ASSETS',
    FAILURE_EXCHANGE_All_ASSETS: 'FAILURE_EXCHANGE_All_ASSETS',

    START_TRANSFER: 'START_TRANSFER',
    SUCCESS_TRANSFER: 'SUCCESS_TRANSFER',
    FINISH_TRANSFER: 'FINISH_TRANSFER',
    FAILURE_TRANSFER: 'FAILURE_TRANSFER',

    START_GET_MAX_AMOUNT: 'START_GET_MAX_AMOUNT',
    SUCCESS_GET_MAX_AMOUNT: 'SUCCESS_GET_MAX_AMOUNT',
    FAILURE_GET_MAX_AMOUNT: 'FAILURE_GET_MAX_AMOUNT',
    FINISH_GET_MAX_AMOUNT: 'FINISH_GET_MAX_AMOUNT',

    START_TRANSFER_TO_BANK: 'START_TRANSFER_TO_BANK',
    SUCCESS_TRANSFER_TO_BANK: 'SUCCESS_TRANSFER_TO_BANK',
    FINISH_TRANSFER_TO_BANK: 'FINISH_TRANSFER_TO_BANK',
    FAILURE_TRANSFER_TO_BANK: 'FAILURE_TRANSFER_TO_BANK',

    START_TRANSFER_FROM_IBAN_TO_BANK: 'START_TRANSFER_FROM_IBAN_TO_BANK',
    SUCCESS_TRANSFER_FROM_IBAN_TO_BANK: 'SUCCESS_TRANSFER_FROM_IBAN_TO_BANK',
    FINISH_TRANSFER_FROM_IBAN_TO_BANK: 'FINISH_TRANSFER_FROM_IBAN_TO_BANK',
    FAILURE_TRANSFER_FROM_IBAN_TO_BANK: 'FAILURE_TRANSFER_FROM_IBAN_TO_BANK',

    START_UPLOAD_DOCUMENTS: 'START_UPLOAD_DOCUMENTS',
    SUCCESS_UPLOAD_DOCUMENTS: 'SUCCESS_UPLOAD_DOCUMENTS',
    FINISH_UPLOAD_DOCUMENTS: 'FINISH_UPLOAD_DOCUMENTS',
    FAILURE_UPLOAD_DOCUMENTS: 'FAILURE_UPLOAD_DOCUMENTS',

    START_ORDER_CURRENCY: 'START_ORDER_CURRENCY',
    SUCCESS_ORDER_CURRENCY: 'SUCCESS_ORDER_CURRENCY',
    FINISH_ORDER_CURRENCY: 'FINISH_ORDER_CURRENCY',
    FAILURE_ORDER_CURRENCY: 'FAILURE_ORDER_CURRENCY',

    START_ORDER_MULTI_CURRENCY: 'START_ORDER_MULTI_CURRENCY',
    SUCCESS_ORDER_MULTI_CURRENCY: 'SUCCESS_ORDER_MULTI_CURRENCY',
    FINISH_ORDER_MULTI_CURRENCY: 'FINISH_ORDER_MULTI_CURRENCY',
    FAILURE_ORDER_MULTI_CURRENCY: 'FAILURE_ORDER_MULTI_CURRENCY',

    START_PAY_NOW: 'START_PAY_NOW',
    SUCCESS_PAY_NOW: 'SUCCESS_PAY_NOW',
    FINISH_PAY_NOW: 'FINISH_PAY_NOW',
    FAILURE_PAY_NOW: 'FAILURE_PAY_NOW',

    START_MAX_FEES: 'START_MAX_FEES',
    SUCCESS_MAX_FEES: 'SUCCESS_MAX_FEES',
    FINISH_MAX_FEES: 'FINISH_MAX_FEES',
    FAILURE_MAX_FEES: 'FAILURE_MAX_FEES',

    START_BANK_BIC: 'START_BANK_BIC',
    SUCCESS_BANK_BIC: 'SUCCESS_BANK_BIC',
    FINISH_BANK_BIC: 'FINISH_BANK_BIC',
    FAILURE_BANK_BIC: 'FAILURE_BANK_BIC',

    START_COMPANY_PAYMENT_CARD: 'START_COMPANY_PAYMENT_CARD',
    SUCCESS_COMPANY_PAYMENT_CARD: 'SUCCESS_COMPANY_PAYMENT_CARD',
    FINISH_COMPANY_PAYMENT_CARD: 'FINISH_COMPANY_PAYMENT_CARD',
    FAILURE_COMPANY_PAYMENT_CARD: 'FAILURE_COMPANY_PAYMENT_CARD',

    START_SECURE_3D_COMPANY_CARD_PAYMENT: 'START_SECURE_3D_COMPANY_CARD_PAYMENT',
    SUCCESS_SECURE_3D_COMPANY_CARD_PAYMENT: 'SUCCESS_SECURE_3D_COMPANY_CARD_PAYMENT',
    FINISH_SECURE_3D_COMPANY_CARD_PAYMENT: 'FINISH_SECURE_3D_COMPANY_CARD_PAYMENT',
    FAILURE_SECURE_3D_COMPANY_CARD_PAYMENT: 'FAILURE_SECURE_3D_COMPANY_CARD_PAYMENT',

    START_COMPANY_PAYMENT_ONLINE_BANKING: 'START_COMPANY_PAYMENT_ONLINE_BANKING',
    SUCCESS_COMPANY_PAYMENT_ONLINE_BANKING: 'SUCCESS_COMPANY_PAYMENT_ONLINE_BANKING',
    FINISH_COMPANY_PAYMENT_ONLINE_BANKING: 'FINISH_COMPANY_PAYMENT_ONLINE_BANKING',
    FAILURE_COMPANY_PAYMENT_ONLINE_BANKING: 'FAILURE_COMPANY_PAYMENT_ONLINE_BANKING',

    START_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: 'START_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT',
    SUCCESS_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: 'SUCCESS_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT',
    FINISH_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: 'FINISH_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT',
    FAILURE_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: 'FAILURE_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT',

    START_TRANSLITERATION_TRANSFER_REFERENCE: 'START_TRANSLITERATION_TRANSFER_REFERENCE',
    SUCCESS_TRANSLITERATION_TRANSFER_REFERENCE: 'SUCCESS_TRANSLITERATION_TRANSFER_REFERENCE',
    FINISH_TRANSLITERATION_TRANSFER_REFERENCE: 'FINISH_TRANSLITERATION_TRANSFER_REFERENCE',
    FAILURE_TRANSLITERATION_TRANSFER_REFERENCE: 'FAILURE_TRANSLITERATION_TRANSFER_REFERENCE',
}

export default ledgerActionTypes
